/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

// export const LIST_ASSETS = gql`
//     query Query($listAssetsSize: Int, $listAssetsOffset: Int) {
//         listAssets(size: $listAssetsSize, offset: $listAssetsOffset) {
//             pagination {
//                 nextOffset
//                 totalItems
//             }
//             results {
//                 item {
//                     assetGroup
//                     assetId
//                     name
//                     img
//                     category
//                     price
//                     symbol
//                     secondaryPrice
//                     secondarySymbol
//                     sold
//                 }
//             }
//         }
//     }
// `;

export const LIST_ASSETS = gql`
query Query($size: Int, $offset: Int,$filter: AssetFilter) {
  getAssets(size: $size, offset: $offset, filter : $filter) {
    data {
      idx
      img
      category
      serialNo
      subtitle
      title
      price {
        amount
        currency
        sale {
          salePrice
          saleEndDate
        }
      }
    }
    currentPage
    totalCount
    pageSize
    totalPages
  }
}
`;
